import { Col, Row } from "antd";
import React from "react";
import Moment from "react-moment";
import { Skill } from "../model/Skill";
import { Company } from "./Company";
import { SocialTypeId } from "../social/Social.model";
import { CompanyImage } from "./Company.Image";
import { CompanyHelper } from "./Company.Helper";

interface CompanyListItemProps {
  company: Company;
  showAdminActions?: boolean;
}

export function CompanyListItem(props: CompanyListItemProps) {
  let company = props.company;
  return (
    <div className={`CompanyListItem`}>
      <Row gutter={[16, 10]}>
        <Col span={4}>{company.id}</Col>
        <Col span={4}>{company.dl}</Col>

        <Col span={4}>
          <CompanyImage width={30} company={company} />
        </Col>
        <Col span={4}>
          {company.socialLinks?.find(sl => sl.type.id === SocialTypeId.LINKEDIN) && (
            <a href={company.socialLinks.find(sl => sl.type.id === SocialTypeId.LINKEDIN)?.url}>
              LinkedIn
            </a>
          )}
          {!company.socialLinks?.find(sl => sl.type.id === SocialTypeId.LINKEDIN) && <>LinkedIn Not Found</>}
        </Col>

        {props.showAdminActions && (
          <Col span={8}>
            <a href={CompanyHelper.getEditUrl(company)} target="_blank">
              Edit
            </a>
          </Col>
        )}
      </Row>
    </div>
  );
}
